import { render, staticRenderFns } from "./ProjectMergeDialog.vue?vue&type=template&id=9ba2280e&scoped=true"
import script from "./ProjectMergeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectMergeDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectMergeDialog.vue?vue&type=style&index=0&id=9ba2280e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2280e",
  null
  
)

export default component.exports